import React from 'react';
import { Button } from '../ui/Button';
import { CountdownTimer } from '../ui/CountdownTimer';
import { CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-16 md:py-24 bg-slate-950 px-4 scroll-mt-10" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <div className="bg-slate-900 rounded-3xl shadow-2xl border border-slate-700 overflow-hidden" data-id="element-111">
          <div className="bg-blue-950 p-8 text-center relative overflow-hidden" data-id="element-112">
            <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500 rounded-full blur-3xl opacity-20 -mr-10 -mt-10" data-id="element-113"></div>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 relative z-10" data-id="element-114">
              Oferta Especial de Lanzamiento
            </h2>
            <p className="text-slate-300 relative z-10" data-id="element-115">
              Empieza tu carrera como editor profesional hoy
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-116">
            <div className="mb-6" data-id="element-117">
              <div className="inline-block bg-red-500 text-white text-xs md:text-sm font-extrabold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4 animate-pulse" data-id="element-118">
                🔥 Solo por hoy — Precio de lanzamiento 🔥
              </div>
              <span className="block text-slate-500 line-through text-xl font-medium" data-id="element-119">
                Precio real: $150.000 ARS
              </span>
              <div className="flex items-center justify-center gap-3 mt-2" data-id="element-120">
                <span className="text-white text-5xl md:text-6xl font-extrabold tracking-tight" data-id="element-121">
                  $59.000
                </span>
                <span className="text-slate-500 font-medium text-lg mt-4" data-id="element-122">
                  ARS
                </span>
              </div>
              <p className="text-yellow-400 font-semibold text-sm mt-2" data-id="element-123">
                ⚡ Este precio no se va a repetir. Después vuelve al precio
                original.
              </p>
            </div>

            {/* Cuotas */}
            <div className="bg-blue-950/50 border border-blue-900/50 rounded-xl p-4 mb-6 inline-flex items-center gap-3" data-id="element-124">
              <CreditCard className="w-5 h-5 text-blue-400 flex-shrink-0" data-id="element-125" />
              <span className="text-blue-300 font-semibold text-sm md:text-base" data-id="element-126">
                O pagá en 3 cuotas sin interés de $19.667 ARS
              </span>
            </div>

            <div className="bg-blue-950/30 border border-blue-900/50 rounded-2xl p-6 mb-8" data-id="element-127">
              <p className="text-blue-400 font-bold text-lg" data-id="element-128">
                Pago único. Acceso de por vida.
              </p>
            </div>

            <div className="text-left mb-8 bg-slate-800/50 p-6 rounded-2xl border border-slate-700" data-id="element-129">
              <h3 className="text-white font-bold mb-4 text-lg" data-id="element-130">
                Si entrás hoy te llevás:
              </h3>
              <ul className="space-y-3" data-id="element-131">
                {['+25 clases paso a paso desde 0, sin experiencia previa', 'Edición profesional en capcut, para todas las redes sociales', 'Masterclass: Como crear guiones con IA (Incluye el Agente de GPT)', '+1000 recursos descargables con un par de clicks', 'Musica viral, transiciones, efectos de sonido, videos de stock, plantillas graficas incluidas', 'Comunidad con editores y alumnos exitosos', 'Soporte personalizado y feedback 24/7'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-132">
                    <svg className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-133">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-134" />
                    </svg>
                    <span className="text-slate-300 text-sm md:text-base" data-id="element-135">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <Button href="https://brunocairo.com/cart/50636149457129:1" size="xl" isExternal fullWidth className="text-xl mb-4" data-id="element-136">
              Acceder ahora con descuento
            </Button>

            <div className="mt-6 flex items-center justify-center gap-2 text-green-400" data-id="element-137">
              <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-138">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-139" />
              </svg>
              <span className="font-semibold text-sm" data-id="element-140">
                Garantía de 7 días: si no te gusta, te reembolsamos. Sin
                preguntas.
              </span>
            </div>

            <p className="text-sm text-slate-500 mt-4" data-id="element-141">
              Pago único o en 3 cuotas sin interés. Acceso de por vida a todas
              las actualizaciones.
            </p>
          </div>
        </div>

        {/* Certificado Section (Outside the main pricing box) */}
        <div className="mt-8 bg-slate-900 rounded-3xl shadow-xl border border-slate-800 p-6 md:p-8 flex flex-col md:flex-row items-center gap-6" data-id="element-142">
          <div className="w-24 h-24 md:w-32 md:h-32 flex-shrink-0" data-id="element-143">
            <img src="https://cdn.magicpatterns.com/uploads/fPLyTenPT13udQ9guyvjpp/imagen_2026-03-10_092945070.png" alt="Certificado de finalización" className="w-full h-full object-contain drop-shadow-2xl" data-id="element-144" />
          </div>
          <div className="text-center md:text-left" data-id="element-145">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-146">
              Certificado de finalización incluido
            </h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-147">
              Demostrá tus nuevas habilidades con un certificado digital que
              podés añadir a tu portfolio, LinkedIn o incluso compartir con
              clientes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}